// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { twoTrianglesBetweenLines } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-two-triangles-between-lines': IconTwoTrianglesBetweenLines;
    }
}

/**
 * The icon component for the 'twoTrianglesBetweenLines' icon
 */
export class IconTwoTrianglesBetweenLines extends IconSvg {
    public constructor() {
        super(twoTrianglesBetweenLines);
    }
}

registerIconSvg('icon-two-triangles-between-lines', IconTwoTrianglesBetweenLines);
export const iconTwoTrianglesBetweenLinesTag = 'nimble-icon-two-triangles-between-lines';
